import { render, staticRenderFns } from "./ConsentTermIframe.vue?vue&type=template&id=1270d845"
import script from "./ConsentTermIframe.vue?vue&type=script&lang=js"
export * from "./ConsentTermIframe.vue?vue&type=script&lang=js"
import style0 from "./Term.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports